module.exports = __webpack_public_path__ + "img/selected0-min.2db5862e.png";